import React, { useMemo, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";
import { IFlexSavings } from "api/individual-savings/types";
import { ReactComponent as MenuDotsIcon } from "assets/icons/menu-dots.svg";
// import { IFlexSavingsListData } from "features/individuals-savings/types";
import {
  IMoreQuickActionItem, // IMoreQuickActionsProps,
  TQuickActionType,
} from "features/individuals/individual-details/more-quick-actions/types";
import {
  individualDetailsQuickActionBtnCss3,
  moreQuickActionsDropDownPopUpMenuContentCss3, // moreQuickActionsDropDownPopUpMenuContentCss4,
} from "features/individuals/individual-details/styles";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { DropDown } from "ui/dropdown";
import { IDropDownRef } from "ui/dropdown/types";
// import { TTableRowData } from "ui/table/types";
import { Paragraph3 } from "ui/typography";

import { CloseSavingsModal } from "../../CloseSavingsModal";

// import { ISavingsItem } from "./types";

const textColorMap: Record<TQuickActionType, string> = {
  regular: "#1A202C",
  disabled: "#344054",
  danger: "#DC2626",
};
const DROP_DOWN_WIDTH = 240;

interface INewMoreQuickActionsProps {
  individualsSavingDetails: IFlexSavings;
}

export const MoreQuickActions = (props: INewMoreQuickActionsProps) => {
  const { individualsSavingDetails } = props;

  const navigate = useNavigate();
  const [isCloseSavingsModalOpen, setIsCloseSavingsModalOpen] = useState(false);
  const dropDownRef = useRef<IDropDownRef | null>(null);

  const handleToggleCloseSavingsModal = () =>
    setIsCloseSavingsModalOpen(!isCloseSavingsModalOpen);

  const handleToggleDropDown = () => {
    if (!dropDownRef.current) return;
    dropDownRef.current.handleToggleDropdown();
  };
  // const enabledStatus = ["active", "paused"];
  const quickActions: IMoreQuickActionItem[] = useMemo(() => {
    if (!individualsSavingDetails) return [];
    // const { id, isGoalSavingsPaused } = individualsSavingDetails;
    // const { type } = individualsSavingDetails;
    // const isPauseResumeDisabled = !enabledStatus.includes(status);

    return [
      {
        label: "View Savings Details",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_FLEX_SAVINGS_PAGE}/${individualsSavingDetails?.id}/view-savings-details`
          );
        },
        type: "regular",
      },
      {
        label: "View Saving’s History",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_FLEX_SAVINGS_PAGE}/${individualsSavingDetails?.id}/view-savings-history`
          );
        },
        type: "regular",
      },
      {
        label: "Close Savings",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          handleToggleCloseSavingsModal();
        },
        type: "danger",
      },
    ];
  }, []);

  return (
    <>
      <DropDown
        dropDownWidth={DROP_DOWN_WIDTH}
        dropDownBtnContent={
          <>
            <MenuDotsIcon className="w-4 h-4" />
          </>
        }
        allowOutSideClick
        customDropDownButtonCss={individualDetailsQuickActionBtnCss3}
        dropDownPopUpMenuContentCss={
          moreQuickActionsDropDownPopUpMenuContentCss3
        }
        ref={dropDownRef}
      >
        <Box className="flex flex-col">
          {quickActions.map(
            ({ label, isDisabled, handleQuickActionItemClick, type }, idx) => {
              return (
                <Box
                  className={`h-10 py-[10px] flex items-center ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                  key={idx}
                  onClick={handleQuickActionItemClick}
                >
                  <Paragraph3
                    textColor={textColorMap[type]}
                    lineHeight="20px"
                    fontWeight="600"
                  >
                    {label}
                  </Paragraph3>
                </Box>
              );
            }
          )}
        </Box>
      </DropDown>
      <CloseSavingsModal
        isOpen={isCloseSavingsModalOpen}
        setIsOpen={setIsCloseSavingsModalOpen}
        handleToggleCloseSavingsModal={handleToggleCloseSavingsModal}
        id={individualsSavingDetails.id}
        type="flex"
      />
    </>
  );
};
